enum CqsOnlineStatoProcessoDocumentiDaFirmare {
    DaAvviare = "DaAvviare",
    InCorso = "InCorso",
    Completato = "Completato",
}

export default CqsOnlineStatoProcessoDocumentiDaFirmare;
